import styled from 'styled-components';
import {
  TableContainer as TableContainerMui,
  Table as TableMui,
  TableCell as TableCellMui,
  TableHead as TableHeadMui,
  TableRow as TableRowMui,
  TableBody as TableBodyMui,
} from '@mui/material';

export const TableContainer = styled(TableContainerMui)`
  background: white;
  border-radius: 0.5rem;
`;

export const Table = styled(TableMui)``;

export const TableHead = styled(TableHeadMui)``;

export const TableRow = styled(TableRowMui)<{
  disabled?: boolean;
  activeRow?: boolean;
}>`
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5 !important;
    pointer-events: none;
    cursor: not-allowed;
    background-color: #f0f0f0 !important;
    border: 2px solid transparent !important;
  `}

  ${({ activeRow }) =>
    activeRow &&
    `
    background-color: #b5ffe9 !important;
    border: 2px solid orange;
  `}

  ${({ disabled, activeRow }) =>
    !disabled &&
    !activeRow &&
    `
      &:nth-child(odd) {
        background-color: #ffffff;
      }

      &:nth-child(even) {
      background-color: #efefef;
      }
    `}
`;

export const TableBody = styled(TableBodyMui)``;

export const TableCell = styled(TableCellMui)<{ activeCell?: boolean }>`
  padding: 8px !important;
  display: inline-flex;
  align-items: center;
  line-height: 1 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;

  ${({ activeCell }) =>
    activeCell &&
    `
    box-shadow: inset 0 0 0 2px orange;
  `}
`;

export const RoundsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  justify-content: center;
`;

export const RoundCell = styled.div<{ isCurrentRound: boolean }>`
  flex: 0 0 auto;
  min-width: 50px;
  text-align: center;
  padding: 8px;
  border: ${({ isCurrentRound }) =>
    isCurrentRound ? '2px solid #007bff' : '1px solid #ccc'};
  background-color: ${({ isCurrentRound }) =>
    isCurrentRound ? '#e6f7ff' : 'white'};
  font-weight: ${({ isCurrentRound }) => (isCurrentRound ? 'bold' : 'normal')};
  cursor: pointer;

  &:hover {
    background-color: ${({ isCurrentRound }) =>
      isCurrentRound ? '#d6efff' : '#f9f9f9'};
  }
`;

export const Players = styled.div``;

export const StaticCell = styled(TableCell)``;

export const Player = styled.div`
  display: flex;
  gap: 0.675rem;
  align-items: center;

  img {
    width: 30px;
  }
`;

export const PlayerName = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const PlayerCursor = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid #ff8000;
  border-radius: 50%;
  background-color: orange;
`;

export const SwitcherContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const HiddenRadio = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

export const Switcher = styled.label<{ isActive: boolean }>`
  width: 50px;
  height: 25px;
  background-color: ${({ isActive }) => (isActive ? 'green' : 'grey')};
  border-radius: 15px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;

  &:before {
    content: '';
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    position: absolute;
    top: 2.5px;
    left: ${({ isActive }) => (isActive ? 'calc(100% - 22.5px)' : '2.5px')};
    transition: left 0.3s ease;
  }
`;

export const CenteredContainer = styled.div`
  display: flex;
  margin: 1rem;
  padding-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  border-bottom: 2px solid #e3e3e3;
`;

export const StatusDialog = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  button {
    margin-top: auto;
  }
`;
